import React from 'react';

interface SeparatorProps {
  text: string;
}

const Separator: React.FC<SeparatorProps> = ({ text }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <div style={{ flex: 1, height: '1px', backgroundColor: 'lightgray' }}></div>
      <span style={{ padding: '0 10px', color: 'gray' }}>{text}</span>
      <div style={{ flex: 1, height: '1px', backgroundColor: 'lightgray' }}></div>
    </div>
  );
};

export default Separator;